// extracted by mini-css-extract-plugin
export var beta = "beta-module--beta--37db6";